import styled from 'styled-components';

import { Spacer } from '@ontruck/orc';

const DetailTitle = styled(Spacer).attrs(() => ({ mBottom: 'XS' }))`
  text-transform: uppercase;
  font-size: ${(props) => props.theme.base.textSizes.S};
  color: var(--greyWolf);
  font-weight: bold;
`;

export default DetailTitle;
